module.exports = __webpack_public_path__ + "static/media/1-guardian-1.e6ae973f.webp";